<template>
  <div>
    <template v-if="users === null">
      <loader />
    </template>
    <template v-else>
      <b-table
        ref="selectableTable"
        striped
        hover
        responsive
        :items="users"
        :fields="fields"
        selectable
        selected-variant="success"
        @row-selected="onRowSelected"
        tbodyTrClass="cursor-pointer"
        select-mode="single"
      >
        <template v-slot:cell(superuser)="{ item }">
          {{ item.superuser ? '&check;' : '&nbsp;' }}
        </template>
        <template v-slot:cell(user.language)="{ item }">
          {{ languagesOptions[item.user.language] }}
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import Loader from '@/components/utils/Loader.vue';
import { mapState } from 'vuex';
import eventBus from '@/components/utils/slideout-panel/eventBus';


export default {
  name: 'UsersManagement',
  components: { Loader },
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('users-management'),
        },
      ],
      users: null,
      fields: [
        { key: 'user.username', label: this.$t('username') },
        { key: 'user.first_name', label: this.$t('first-name') },
        { key: 'user.last_name', label: this.$t('last-name') },
        { key: 'user.language', label: this.$t('choose-language') },
        'role',
        'superuser',
      ],
      languagesOptions: {
        1: 'EN',
        2: 'CZ',
      },
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
  },
  methods: {
    onRowSelected(items) {
      eventBus.$emit('userSelected', items[0] ? items[0] : null);
    },
    loadUsers() {
      const url = new URL(
        config.ICOOL.API.USERS_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      axios
        .get(url)
        .then((response) => {
          this.users = response.data;
        });
    },
  },
  mounted() {
    this.loadUsers();
  },
  created() {
    eventBus.$on('users-updated', this.loadUsers);
  },
  destroyed() {
    eventBus.$off('users-updated');
  },
};
</script>

<style scoped>

</style>
